module.exports = __webpack_public_path__ + "img/map-mexico.70c9cddd.jpg";